namespace AgerLMS.Coaching {
    export interface AgendaEvent {
        id?: number;
        title?: string;
        start?: string;
        end?: string;
        backgroundColor?: string;
        borderColor?: string;
        color?: string;
        textColor?: string;
        day?: string;
    }
}
